import { CircularProgress, Grid } from '@mui/material';
import { GridRowSelectionModel } from '@mui/x-data-grid';
import React from 'react';

import { useReportingHubPageContext } from '../../pages/ReportingHubPageContext';
import ReportTemplateItem from './ReportTemplateItem';

interface User {
  id: number;
  name: string;
}
interface ReportTemplateListByUserProps {
  userList: User[];
  selectedReportTemplateIds: GridRowSelectionModel;
  setSelectedReportTemplateIds: (ids: GridRowSelectionModel) => void;
}

function ReportTemplateListByUser({
  userList,
  selectedReportTemplateIds,
  setSelectedReportTemplateIds,
}: ReportTemplateListByUserProps) {
  const { reportTemplates, isLoading } = useReportingHubPageContext();

  return (
    <>
      {isLoading && <CircularProgress />}
      {!isLoading && (
        <Grid container spacing={2}>
          {reportTemplates?.map((item) => (
            <Grid item xs={3} key={item.id}>
              <ReportTemplateItem
                reportTemplate={item.template?.reportTemplate}
                ownerName={userList?.find((user) => user.id === item.userId)?.name}
                selectedReportTemplateIds={selectedReportTemplateIds}
                setSelectedReportTemplateIds={setSelectedReportTemplateIds}
              />
            </Grid>
          ))}
        </Grid>
      )}
    </>
  );
}

export default ReportTemplateListByUser;
